import { render, staticRenderFns } from "./coach-rebates.vue?vue&type=template&id=35a83007&scoped=true"
import script from "./coach-rebates.vue?vue&type=script&lang=js"
export * from "./coach-rebates.vue?vue&type=script&lang=js"
import style0 from "./coach-rebates.vue?vue&type=style&index=0&id=35a83007&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a83007",
  null
  
)

export default component.exports